/**
 * Defence in depth for the consent hand-off (security review
 * 2026-10-29, S1-S3 MINOR-5). The server validates `redirect_url`
 * against the client's registered redirect URIs before returning it;
 * this check only refuses to navigate if that validation ever drifts.
 *
 * Accepts https anywhere, and plain http only on loopback hosts (Claude
 * Code's RFC 8252 callback). Everything else — javascript:, data:,
 * protocol-relative, http to a public host — is refused.
 */
export function isSafeRedirectUrl(raw: string): boolean {
  if (typeof raw !== 'string' || raw.length === 0 || raw.length > 4096) return false;
  let u: URL;
  try {
    u = new URL(raw);
  } catch {
    return false;
  }
  if (u.username !== '' || u.password !== '') return false;
  if (u.protocol === 'https:') return true;
  if (u.protocol === 'http:') {
    // IPv6 loopback: WHATWG `URL` keeps the brackets in `hostname`
    // (Node, jsdom, modern browsers), but older runtimes and some
    // polyfills strip them. Accept both forms so `http://[::1]:9/cb`
    // is honoured regardless of which parser we're on.
    return (
      u.hostname === 'localhost'
      || u.hostname === '127.0.0.1'
      || u.hostname === '[::1]'
      || u.hostname === '::1'
    );
  }
  return false;
}
